import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import client from "../api/client";
import { formatDateFull, formatCurrency } from "../utils/format";
import { ArrowLeft, Loader2, Mail, Phone } from "lucide-react";

function WorkshopRow({ w, muted }) {
  return (
    <div className={`border border-border rounded-lg p-4 ${muted ? "opacity-60" : ""}`} data-testid={`lector-ws-${w.id}`}>
      <div className="flex items-center justify-between">
        <div>
          <div className="font-medium">{w.school_name}</div>
          <div className="text-sm text-muted-foreground">{formatDateFull(w.date)} · {w.time_from}–{w.time_to} · {w.program_name}</div>
          <div className="text-sm text-muted-foreground">{w.address}</div>
        </div>
        <span className="text-xs px-2 py-1 rounded-full" style={{ background: (w.status_color || "#999") + "22", color: w.status_color }}>{w.status_name}</span>
      </div>
    </div>
  );
}

export default function LectorDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    client.get(`/lectors/${id}`).then((res) => setData(res.data));
  }, [id]);

  if (!data) return <div className="p-8 text-sm text-muted-foreground flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" /> Načítání…</div>;

  const l = data.lector;
  return (
    <>
      <div className="h-16 border-b border-border px-8 flex items-center gap-3 sticky top-0 bg-background/80 backdrop-blur-md z-10">
        <button onClick={() => navigate("/lectors")} className="p-2 rounded-md hover:bg-secondary"><ArrowLeft className="h-4 w-4" /></button>
        <h1 className="font-heading text-xl font-semibold tracking-tight">{l.name}</h1>
      </div>
      <div className="p-8 space-y-8 max-w-3xl">
        <div className="flex gap-4 text-sm">
          {l.email && <a href={`mailto:${l.email}`} className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground"><Mail className="h-4 w-4" /> {l.email}</a>}
          {l.phone && <a href={`tel:${l.phone}`} className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground"><Phone className="h-4 w-4" /> {l.phone}</a>}
        </div>

        <div>
          <h2 className="font-heading text-lg font-medium mb-3">Nadcházející akce ({data.upcoming.length})</h2>
          <div className="space-y-2">
            {data.upcoming.map((w) => <WorkshopRow key={w.id} w={w} />)}
            {data.upcoming.length === 0 && <p className="text-sm text-muted-foreground">Žádné nadcházející akce</p>}
          </div>
        </div>

        <div>
          <h2 className="font-heading text-lg font-medium mb-3">Proběhlé akce ({data.past.length})</h2>
          <div className="space-y-2">
            {data.past.map((w) => <WorkshopRow key={w.id} w={w} muted />)}
            {data.past.length === 0 && <p className="text-sm text-muted-foreground">Žádné proběhlé akce</p>}
          </div>
        </div>
      </div>
    </>
  );
}
